import React from 'react';
import { useLocation } from 'react-router-dom';
import PolicyReport from '../LifePolicyRegister/PolicyReport';

// CurrentStatusReportPreview simply re-uses the existing PolicyReport component.
// The CurrentStatusReport form navigates to this route and passes payload in location.state.payload
// PolicyReport reads location.state.payload and will generate the report accordingly.
export default function LapsedPoliciesReportGenerate() {
  const location = useLocation();
  const payload = location?.state?.payload ?? {};
  const fupFrom = payload?.fromDate ?? null;
  const fupTo = payload?.toDate ?? null;

  // include FUP sort option for Lapsed Policies report and set header
  return (
    <PolicyReport
      includeLapsedDate={true}
      includePolicyStatus={true}
      includeFUPDate={true}
      fupFrom={fupFrom}
      fupTo={fupTo}
      headerTitle={"Lapsed Policies Report"}
      reportType="LapsedReport"
      extraSortOptions={[{ key: 'fup', label: 'FUP Date' }]}
      initialSort={'fup'}
    />
  );
}
